import { combineReducers } from 'redux';

import { step } from './step';
import { backgroundColor } from './backgroundColor';
import { deviceType } from './deviceType';

export const rootReducer = combineReducers({
    step,
    backgroundColor,
    deviceType,
});
